"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeadersApi = void 0;

var _invoke = _interopRequireDefault(require("../../util/invoke"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {String} basePath
 * @param {String} projectKey
 * @returns {Promise}
 */
const getHeadersApi = (basePath, projectKey) => {
  return (0, _invoke.default)({
    method: 'GET',
    url: "".concat(basePath, "/v2/notifications/header/"),
    headers: {
      'platform-subscriber-id': projectKey
    }
  });
};

exports.getHeadersApi = getHeadersApi;